import { Component } from '@angular/core';
import { NavigationComponent } from '../navigation/navigation.component';
import { NavigationMobileComponent } from '../navigationmobile/navigationmobile.component';

@Component({
	selector: 'app-header-component',
	template: `<app-navigation-mobile-component class="fixed-top d-sm-block d-sm-block d-md-none" />
		<app-navigation-component class="d-none d-md-block" /> `,
	styles: [
		`
			@media screen and (max-width: 1201px) {
				.d-md-none {
					display: block !important;
				}
				.d-md-block {
					display: none !important;
				}
			}
		`
	],
	imports: [NavigationComponent, NavigationMobileComponent]
})
export class HeaderComponent {}
